import styled, { css } from 'styled-components';

import Tooltip from '~/components/Tooltip';

interface SelectBlockProps {
  isFocused: boolean;
  isErrored: boolean;
  isDisabled?: boolean;
}

interface SelectLabelProps {
  isFocused: boolean;
}

export const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 200px;
`;

export const SelectBlock = styled.div<SelectBlockProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: #ffffff;
  width: 100%;
  border: 0.5px solid;
  border-radius: 4rem;
  transition: all 0.2s ease-in-out;
  z-index: 2;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.black};
  letter-spacing: 0.28px;
  padding: 0.5rem 1rem;
  transition: all 0.2s ease-in-out;

  ${(props) =>
    props.isErrored &&
    css`
      border-color: #c53030;
    `}

  /* Se o input estiver focado, mude a cor do icone e da borda. A cor do icone esta conectado com color */
  ${(props) =>
    props.isFocused &&
    css`
      color:   border: 1px solid #e4007d;
      border-color:   border: 1px solid #e4007d;
    `}

  ${(props) =>
    props.isDisabled &&
    css`
      border-color: #00000024 !important;
      color: #00000050 !important;
    `}
`;

export const SelectField = styled.select<SelectLabelProps>`
  appearance: none;
  all: unset;
  width: 100%;

  option {
    font-size: 1.4rem;
    font-weight: 400;
    color: #000000;
    letter-spacing: 0.28px;
  }
`;

export const SelectError = styled(Tooltip)`
  height: 20px;

  svg {
    margin-right: 0;
    margin-left: 15px;
  }
`;

export const Label = styled.label`
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.black};
  padding: 0 0 0.6rem 1.2rem;
  user-select: none;
`;
